import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { clearCompany, getCompanyId } from "../../util/accounting/company";

/**
 * Closes the open company whenever accounting is left.
 *
 * The menu's own exits do this themselves, but accounting can also be left by
 * the logo, a header link or the back button, and leaving is leaving however it
 * happens: the next visit should ask which company to open rather than quietly
 * resuming the last one. Posting into the wrong company is the one mistake here
 * that is expensive to undo, so the books are never left open behind you.
 *
 * That includes landing outside accounting on a fresh page load — several links
 * in this system are plain hrefs that reload rather than route — so the check
 * runs on mount too. It is safe to do that because the open company is kept per
 * tab: closing it here cannot pull another tab out of the books it is in.
 */
export default function CompanySession() {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith("/accounting") && getCompanyId()) {
      clearCompany();
    }
  }, [location.pathname]);

  return null;
}
